const BASE = 'https://fipe.parallelum.com.br/api/v2';

const get = async url => {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Erro ao consultar FIPE');
  return res.json();
};

export const fipe = {
  marcas: () => get(`${BASE}/cars/brands`),
  modelos: marcaId => get(`${BASE}/cars/brands/${marcaId}/models`),
  anos: (marcaId, modeloId) => get(`${BASE}/cars/brands/${marcaId}/models/${modeloId}/years`),
};
